/* EUR price step -> RON shelf price. Regenerated 11 August 2026.

   THE SHOPIFY PRICE LIST IS THE SOURCE OF TRUTH, not this file. "Romania RON",
   gid://shopify/PriceList/40713453906, carries the same 92 figures and is what
   the customer is actually charged. This map exists so the configurator can
   SHOW a leu price before anything reaches the cart. If the two ever disagree,
   this file is the one that is wrong. Reprice in both places in one pass.

   How the numbers are built, on the markup rule the client chose on 11 August:
     net  = Anwis list x 0.70 (dealer discount) x 1.5 (50 % markup)
     EUR  = net x 1.19 (German VAT), rounded up to a figure ending in 9
     RON  = net x 1.21 (Romanian VAT) x 5.2396 (BNR, 11 August 2026), same
            rounding
   Both markets run the same rule, so the leu price is a fixed multiple of the
   euro step: (1.21 / 1.19) x 5.2396 = 5.32766. That is the only reason a plain
   map works here at all.

   The previous map used 4.26839, from when Romania sat at a 50 % margin and
   Germany at 60 %. Both are gone.

   The three lowest steps - 49, 59, 69 - are new. At this markup the cheapest
   manufacturable blind (bamboo 25, smallest priced cell, 39 list) comes to
   49 EUR, below where the ladder used to start; without them the snap would
   have silently raised the cheapest blinds to 79.

   A step missing from this map is NOT filled in from the euro price. The
   configurator shows "price on request" and blocks the button instead -
   quoting a currency the shop does not charge in is worse than quoting
   nothing. */
window.NARU_RON = {
  49: 269, 59: 319, 69: 369, 79: 429, 89: 479, 99: 529,
  109: 589, 119: 639, 129: 689, 139: 749, 149: 799, 159: 849,
  169: 909, 179: 959, 189: 1009, 199: 1069, 209: 1119, 219: 1169,
  229: 1229, 239: 1279, 249: 1329, 259: 1389, 269: 1439, 279: 1489,
  289: 1549, 299: 1599, 309: 1649, 319: 1709, 329: 1759, 339: 1809,
  349: 1869, 359: 1919, 369: 1969, 379: 2029, 389: 2079, 399: 2129,
  409: 2189, 419: 2239, 429: 2289, 439: 2339, 449: 2399, 459: 2449,
  469: 2499, 479: 2559, 489: 2609, 499: 2659, 519: 2769, 539: 2879,
  559: 2979, 579: 3089, 599: 3199, 629: 3359, 659: 3519, 689: 3679,
  719: 3839, 749: 3999, 779: 4159, 809: 4319, 839: 4479, 869: 4639,
  899: 4799, 929: 4959, 959: 5119, 989: 5279, 1049: 5589, 1099: 5859,
  1149: 6129, 1199: 6389, 1249: 6659, 1299: 6929, 1349: 7189, 1399: 7459,
  1449: 7729, 1499: 7989, 1549: 8259, 1599: 8519, 1649: 8789, 1699: 9059,
  1749: 9319, 1799: 9589, 1849: 9859, 1899: 10119, 1949: 10389, 1999: 10659,
  2099: 11189, 2199: 11719, 2299: 12249, 2399: 12789, 2499: 13319,
  2599: 13849, 2799: 14919, 2999: 15979
};
